module.exports = __webpack_public_path__ + "static/media/Girafarig_gaussian2.e7b84642.png";